/** @jsxImportSource @emotion/react */
import React, {useState} from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import {WidgetContainer, Maps} from 'components'
import {useDependency, useResource} from 'hooks'
import { DEFAULT_WIDGET_REFRESH_MS } from 'constants'
import { Widgets } from './'
import _ from 'lodash'

const RegionalPriceMap = ({mapProps={}, ...other}) => {
  const widget = Widgets['regional-price-map']
  const [price, priceActions] = useResource('price')

  const updateWidget = () => {
    return Promise.all([
      priceActions.request('region'),
      priceActions.request('reserve')
    ])
  }

  const [loading, _result, reload] = useDependency(updateWidget, [])
  const mapUpdatedAt = _.last(price.region?.data?.items || [])?.timestamp

  const [zoom, setZoom] = useState({})
  const zoomCallback = zoom => setZoom(zoom)

  return (
    <WidgetContainer
      widget={widget}
      title="Regional Price Overview ($/MWh)"
      icon={<LocationOnIcon/>}
      lastUpdatedAt={mapUpdatedAt}
      loading={loading}
      onWidgetRefresh={reload}
      widgetAutoRefreshMs={DEFAULT_WIDGET_REFRESH_MS}
      zoom={zoom}
      {...other}
    >
      <Maps.RegionalPrice
        data={{region: price.region?.data, reserve: price.reserve?.data}}
        zoomCallback={zoomCallback}
        {...mapProps}
      />
    </WidgetContainer>
);
}

export default RegionalPriceMap
